import openSocket from 'socket.io-client';
const socket = openSocket(process.env.REACT_APP_ASK_JOEY_URI);
// const socket = null;

function receiveNewMessage(callback) {
    socket.on('newMessage', (message) => {
        callback(message)
    })
}

function initMenu(callback) {
    socket.on('initMenu', (menuItems) => {
        callback(menuItems);
    });
}

function selectMenuItem(menuId, accessToken, callback) {
    socket.emit('selectMenuItem', {menuId, accessToken}, callback);
}


function talkToJoey(optionalParameters, accessToken, type, callback) {
    socket.emit('talkToJoey', {accessToken, type, optionalParameters}, callback);
}

function sendJoeyTextMessage(message, accessToken, callback) {
    socket.emit('sendJoeyTextMessage', {message, accessToken}, callback);
}

function stopTalkingToJoey(accessToken, callback) {
    socket.emit('stopTalkingToJoey', {accessToken}, callback);
}

function sendJoeyAttachmentMessage(attachmentBase64Data, accessToken, callback) {
    socket.emit('sendJoeyAttachmentMessage', {attachmentBase64Data, accessToken}, callback);
}

export { 
    initMenu,
    selectMenuItem,
    talkToJoey,
    sendJoeyTextMessage,
    receiveNewMessage,
    stopTalkingToJoey,
    sendJoeyAttachmentMessage,
};